import * as React from 'react';
export const IcPercentageIncrease = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.983 15a2.994 2.994 0 00-2.768 1.852 3.002 3.002 0 002.183 4.09 2.993 2.993 0 003.076-1.275 3.003 3.003 0 00-.372-3.788 2.994 2.994 0 00-2.12-.879zM5.996 9a2.994 2.994 0 002.769-1.852 3.003 3.003 0 00-2.184-4.09 2.993 2.993 0 00-3.076 1.275A3.003 3.003 0 005.996 9zM18.98 3h-3.995a.998.998 0 00-.706 1.707.998.998 0 00.706.293h1.688L3.27 19.32a1 1 0 000 1.41.997.997 0 00.729.27.998.998 0 00.729-.32L17.982 6.53V8a1 1 0 00.998 1 .998.998 0 001-1V4a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
